class Menu {

    constructor() {
        this.mobileButton = document.querySelector('#navOpener');
    }


    listener_toggleMobileNav() {
        this.mobileButton.addEventListener('click', () => {
            document.body.classList.toggle('js-navOpened');
        })
    }
    
    init(){
        this.listener_toggleMobileNav();
    }
}


export const initMenu = () => {

    const newMenu = new Menu();
    newMenu.init();
}
